import { LegalDocumentType, Query, TenantLegalDocuments } from 'graphql/generated/graphqlTypes';

export function mockedGetTenantLegalDocumentsData(
  getTenantLegalDocuments: TenantLegalDocuments
): Pick<Query, 'getTenantLegalDocuments'> {
  return {
    getTenantLegalDocuments
  };
}

export const mockedGetTenantLegalDocumentsDataForQuery = mockedGetTenantLegalDocumentsData({
  __typename: 'TenantLegalDocuments',
  tenant: {
    __typename: 'BasicTenant',
    tenantId: 'mockedTenantId',
    name: 'mockedTenantName',
    onboardingStep: 'mockedOnboardingStep'
  },
  dpa: {
    __typename: 'LegalDocument',
    documentType: LegalDocumentType.Dpa,
    currentVersion: 'mockedCurrentVersion',
    id: 'DPAid',
    currentText: '<h1>mocked dpa text</h1>',
    acceptedVersion: 'mockedVersion',
    acceptedOn: null
  },
  sla: {
    __typename: 'LegalDocument',
    documentType: LegalDocumentType.Sla,
    currentVersion: 'mockedCurrentVersion',
    id: 'SLAid',
    currentText: '<h1>mocked sla text</h1>',
    acceptedVersion: 'mockedVersion',
    acceptedOn: null
  }
});
